import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';

import _throttle from 'lodash/throttle';

import 'src/app/components/Modal/Modal.scss';


const ESC_CODE = 27;
const SAFARI_BAR_VH = 0.01;
const VIEWPORT_SIZE_CHECKING_DELAY = 500;

/*
 * @HACK: https://css-tricks.com/the-trick-to-viewport-units-on-mobile/
 * function calculates css --vh variable (fix to mobile vh unit)
 */

const calculateViewportHeight = () => {
  const vh = window.innerHeight * SAFARI_BAR_VH;
  window.document.documentElement.style.setProperty('--vh', `${vh}px`);
};

const throttledCalculateViewportHeight = _throttle(
  calculateViewportHeight,
  VIEWPORT_SIZE_CHECKING_DELAY
);

// eslint-disable-next-line max-lines-per-function
const Modal = ({
  header,
  headerIcon,
  onClose,
  children
}) => {
  const handleKeyDown = (event) => {
    if (event.keyCode === ESC_CODE) {
      onClose();
    }
  };

  useEffect(() => {
    document.addEventListener('keydown', handleKeyDown, false);
    calculateViewportHeight();
    window.addEventListener('resize', throttledCalculateViewportHeight);

    return () => {
      document.removeEventListener('keydown', handleKeyDown, false);
      window.removeEventListener('resize', throttledCalculateViewportHeight);
    };
  }, [onClose]);

  return (
    <div styleName="modal">
      {
        ReactDOM.createPortal(
          <div styleName="modal__cover">
            <div
              aria-modal="true"
              role="dialog"
              styleName="modal__container"
            >
              {
                header ? (
                  <div styleName="modal__header">
                    {
                      headerIcon ? (
                        <img alt="" src={ headerIcon } styleName="modal__header-icon" />
                      ) : null
                    }
                    <div styleName="modal__title">
                      {header}
                    </div>
                    <button onClick={ onClose } styleName="modal__close" type="button" />
                  </div>
                ) : null
              }
              <div styleName="modal__content">
                {children}
              </div>
            </div>
          </div>,
          document.body
        )
      }
    </div>
  );
};

Modal.propTypes = {
  children: PropTypes.node.isRequired,
  header: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  headerIcon: PropTypes.string,
  onClose: PropTypes.func
};

Modal.defaultProps = {
  header: null,
  headerIcon: null,
  onClose: () => {}
};

export default Modal;
